import { useWallet } from "@/composables/useWallet";

export default {
	namespaced: true,
	state: () => ({
		isWeb3: true,
		jwt_token: "",
		connected: false,
		address: null,
		adapter: null,
		wallet: null
	}),
	mutations: {
		set_wallet(state, wallet) {
			state.wallet = useWallet(wallet);
		},
		set_wallet_connected(state, connected) {
			state.connected = connected;
		},

		set_wallet_address(state, addr) {
			state.isWeb3 = true
			state.address = addr;
		},

		set_wallet_adapter(state, adapter) {
			state.adapter = adapter;
		},

		set_web2_wallet(state, addr) {
			state.isWeb3 = false
			state.address = addr
		},

		clear_wallet(state) {
			localStorage.removeItem("jwt_token")
			state.isWeb3 = false
			state.connected = false
			state.address = ""
			state.jwt_token = ""
			state.wallet = null
		},

		set_jwt_token(state, token) {
			state.isWeb3 = false
			state.jwt_token = token
			localStorage.setItem("jwt_token", token)

			const base64Url = token.split('.')[1];
			const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
			const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));


			const claims = JSON.parse(jsonPayload)
			if (claims.wallet_addr) {
				state.address = claims.wallet_addr
			}
		}
	},
	actions: {
		walletConnected({commit,dispatch, state}) {
			if (state.connected)
				return
			commit("set_wallet_connected", true)
			dispatch("providers/onConnect", {}, {root: true})
		}
	}
}
